import { AxiosResponse } from 'axios';

import { api } from '@/api';

// 파일 크기 포맷팅
export const formatFileSize = (bytes: number) => {
	if (bytes === 0) return '0 Bytes';
	const k = 1024;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

// 파일 확장자 추출
export const getFileExtension = (filename: string) => filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);

// 파일 타입 체크
export const isImageFile = (filename: string) => {
	const ext = getFileExtension(filename).toLowerCase();
	return ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext);
};

export const downloadPdf = async (pk: string | number, pdfType: 'receipt' | 'transaction') => {
	let response: AxiosResponse;

	if (pdfType === 'receipt') {
		response = await api.get(
			`/v1/front/getReceipt`,
			{
				pay_info_pk: pk,
			},
			{
				responseType: 'blob',
			}
		);
	} else if (pdfType === 'transaction') {
		response = await api.get(
			`/v1/front/getTransaction`,
			{
				pay_info_pk: pk,
			},
			{
				responseType: 'blob',
			}
		);
	} else {
		return;
	}

	const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
	const link = document.createElement('a');
	link.href = downloadUrl;
	if (pdfType === 'receipt') {
		link.setAttribute('download', '대한화장품학회 영수증.pdf');
	} else if (pdfType === 'transaction') {
		link.setAttribute('download', '대한화장품학회 거래명세서.pdf');
	} else {
		link.setAttribute('download', '대한화장품학회 납부내역.pdf');
	}
	document.body.appendChild(link);
	link.click();
	link.remove();
};

export const downloadFile = async (url: string, pk: string) => {
	const fileExtension = url.split('.').pop()?.toLowerCase();
	const isViewable = ['pdf'].includes(fileExtension || '');

	if (isViewable) {
		window.open(url, '_blank');
	} else {
		window.open(`${import.meta.env.VITE_APP_BASE_URL}/v1/common/fileDownload?file_pk=${pk}`);
	}
};

export const downloadFileFromFrontend = (fileUrl: string, filename: string) => {
	const link = document.createElement('a');
	link.href = fileUrl;
	link.download = filename;
	link.style.display = 'none';

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
